import { images } from ".";

const venues = [
    {
        id: 1,
        image: images.venue1,
        title: "Grand Ballroom",
        details: {
            venueType: "Air-Conditioned Function Hall",
            indoorOutdoor: "Indoor",
            eventType: "Wedding, Social, Corporate, Picnic",
            capacity: 300,
            styleDecor: "Traditional Garden",
            area: "8000 sq ft",
            pricing: "Venue Rental Only: $7500, Venue + Catering: $10,000",
            phoneNumber: "+123-456-7890",
            email: "info@venueexample.com",
            address: "Downtown, City Center",
            website: "www.venuewebsite.com",
            parking: "Ample Parking Space"
        },
        paragraphs: [
            "Host your events at our exquisite Grand Ballroom, located in the heart of the city, and experience unmatched elegance and sophistication.",
            "Our Grand Ballroom offers a spacious and luxurious setting perfect for weddings, corporate events, and social gatherings. With state-of-the-art facilities and elegant décor, your event is sure to be a memorable one."
        ],
        gallery: [
            images.venue1Gallery1,
            images.venue1Gallery2,
            images.venue1Gallery3,
            images.venue1Gallery4,
            images.venue1Gallery5,
            images.venue1Gallery6
        ],
        venueSpaces: [
            "Grand Ballroom - Capacity: 300, 8000 sq ft",
            "Conference Room - Capacity: 50",
            "Outdoor Garden - Capacity: 200",
            "Rooftop Terrace - Capacity: 150",
            "VIP Lounge - Capacity: 100"
        ],
        amenities: [
            "24/7 Concierge Service",
            "High-Speed Wi-Fi",
            "Full-Service Catering",
            "Ample Parking Space",
            "Wheelchair Accessibility"
        ],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d95230.86755205364!2d-6.3874382!3d53.3330612!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9dc3c78e6f%3A0x4c7c0b28f310c8a0!2sDublin%2C%20Ireland!5e0!3m2!1sen!2s!4v1715801234567!5m2!1sen!2s" 
    },
    {
        id: 2,
        image: images.venue2,
        title: "Outdoor Garden",
        details: {
            venueType: "Open-Air Garden Venue",
            indoorOutdoor: "Outdoor",
            eventType: "Wedding, Social, Corporate, Picnic",
            capacity: 150,
            styleDecor: "Rustic Nature",
            area: "6000 sq ft",
            pricing: "Venue Rental Only: $5000, Venue + Catering: $8000",
            phoneNumber: "+123-456-7890",
            email: "info@venueexample.com",
            address: "Westside Park, City Center",
            website: "www.venuewebsite.com",
            parking: "Ample Parking Space"
        },
        paragraphs: [
            "Celebrate under the open sky at our stunning Outdoor Garden, nestled in the serene surroundings of Westside Park — a perfect blend of nature and style.",
            "Ideal for weddings, picnics, and outdoor gatherings, this venue features lush greenery, charming décor, and ample space to create unforgettable memories in a natural setting."
        ],
        gallery: [
            images.venue2Gallery1,
            images.venue2Gallery2,
            images.venue2Gallery3,
            images.venue2Gallery4,
            images.venue2Gallery5,
            images.venue2Gallery6
        ],
        venueSpaces: [
            "Outdoor Garden - Capacity: 150, 6000 sq ft",
            "Picnic Lawn - Capacity: 80",
            "Gazebo Pavilion - Capacity: 50",
            "Flower Pathway - Capacity: 30",
            "Outdoor Lounge - Capacity: 100"
        ],
        amenities: [
            "On-Site Event Coordinator",
            "Ambient Outdoor Lighting",
            "Full-Service Catering",
            "Ample Parking Space",
            "Eco-Friendly Setup Options"
        ],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d95230.86755205364!2d-6.3874382!3d53.3330612!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9dc3c78e6f%3A0x4c7c0b28f310c8a0!2sDublin%2C%20Ireland!5e0!3m2!1sen!2s!4v1715801234567!5m2!1sen!2s" 
    },
    {
        id: 3,
        image: images.venue3,
        title: "Private Dining Room",
        details: {
            venueType: "Exclusive Indoor Dining Room",
            indoorOutdoor: "Indoor",
            eventType: "Private Dinner, Business Meeting, Birthday, Engagement",
            capacity: 50,
            styleDecor: "Modern Chic",
            area: "2000 sq ft",
            pricing: "Venue Rental Only: $2500, Venue + Catering: $4500",
            phoneNumber: "+123-456-7890",
            email: "info@venueexample.com",
            address: "Uptown Bistro, City Center",
            website: "www.venuewebsite.com",
            parking: "Valet and Street Parking"
        },
        paragraphs: [
            "Host your intimate gatherings at our Private Dining Room located inside Uptown Bistro, designed for sophistication and personal service.",
            "Perfect for private dinners, executive meetings, or special celebrations, this elegant space combines privacy with upscale ambiance to create memorable experiences."
        ],
        gallery: [
            images.venue3Gallery1,
            images.venue3Gallery2,
            images.venue3Gallery3,
            images.venue3Gallery4,
            images.venue3Gallery5,
            images.venue3Gallery6
        ],
        venueSpaces: [
            "Private Dining Room - Capacity: 50, 2000 sq ft",
            "Chef’s Table Room - Capacity: 20",
            "Lounge Area - Capacity: 30",
            "Terrace Seating - Capacity: 40",
            "Wine Cellar Room - Capacity: 15"
        ],
        amenities: [
            "Dedicated Event Host",
            "Premium Sound System",
            "Customizable Menu",
            "Valet Parking",
            "Wi-Fi and AV Equipment"
        ],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d95230.86755205364!2d-6.3874382!3d53.3330612!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9dc3c78e6f%3A0x4c7c0b28f310c8a0!2sDublin%2C%20Ireland!5e0!3m2!1sen!2s!4v1715801234567!5m2!1sen!2s" 
    },
    {
        id: 4,
        image: images.venue4,
        title: "Rooftop Terrace",
        details: {
            venueType: "Scenic Rooftop Event Space",
            indoorOutdoor: "Outdoor",
            eventType: "Cocktail Party, Engagement, Reception, Networking",
            capacity: 100,
            styleDecor: "Urban Chic",
            area: "3000 sq ft",
            pricing: "Venue Rental Only: $3500, Venue + Catering: $6000",
            phoneNumber: "+123-456-7890",
            email: "info@venueexample.com",
            address: "City View Hotel, Skyline Avenue",
            website: "www.venuewebsite.com",
            parking: "Hotel Basement Parking"
        },
        paragraphs: [
            "Celebrate under the stars at our stunning Rooftop Terrace located atop the City View Hotel, offering panoramic skyline views and a stylish ambiance.",
            "This open-air venue is ideal for chic receptions, social gatherings, and networking events, combining breathtaking scenery with top-tier service and flexible arrangements."
        ],
        gallery: [
            images.venue4Gallery1,
            images.venue4Gallery2,
            images.venue4Gallery3,
            images.venue4Gallery4,
            images.venue4Gallery5,
            images.venue4Gallery6
        ],
        venueSpaces: [
            "Rooftop Terrace - Capacity: 100, 3000 sq ft",
            "Sky Lounge - Capacity: 40",
            "Outdoor Bar - Capacity: 60",
            "VIP Cabana Area - Capacity: 30",
            "Sunset Deck - Capacity: 50"
        ],
        amenities: [
            "360° City View",
            "Ambient Lighting",
            "Bar and Beverage Station",
            "DJ Booth and Sound Setup",
            "On-site Event Manager"
        ],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d95230.86755205364!2d-6.3874382!3d53.3330612!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9dc3c78e6f%3A0x4c7c0b28f310c8a0!2sDublin%2C%20Ireland!5e0!3m2!1sen!2s!4v1715801234567!5m2!1sen!2s" 
    },
    {
        id: 5,
        image: images.venue5,
        title: "Beachside Pavilion",
        details: {
            venueType: "Seaside Event Pavilion",
            indoorOutdoor: "Outdoor",
            eventType: "Beach Party, Wedding, Corporate Retreat, Celebration",
            capacity: 200,
            styleDecor: "Coastal Chic",
            area: "5000 sq ft",
            pricing: "Venue Rental Only: $5000, Venue + Catering: $8500",
            phoneNumber: "+123-456-7890",
            email: "info@venueexample.com",
            address: "Sunny Beach, Ocean Drive",
            website: "www.venuewebsite.com",
            parking: "On-site Beachfront Parking"
        },
        paragraphs: [
            "Host your next unforgettable event at the Beachside Pavilion, located on the pristine shores of Sunny Beach, where the sand meets luxury.",
            "With its breathtaking ocean views, spacious layout, and breezy coastal atmosphere, this venue is perfect for large celebrations and intimate gatherings alike."
        ],
        gallery: [
            images.venue5Gallery1,
            images.venue5Gallery2,
            images.venue5Gallery3,
            images.venue5Gallery4,
            images.venue5Gallery5,
            images.venue5Gallery6
        ],
        venueSpaces: [
            "Beachside Pavilion - Capacity: 200, 5000 sq ft",
            "Private Beachfront Area - Capacity: 100",
            "Oceanfront Lounge - Capacity: 50",
            "Tiki Bar - Capacity: 75",
            "Sunset Deck - Capacity: 120"
        ],
        amenities: [
            "Oceanfront Views",
            "Beach Access",
            "Tented Seating Areas",
            "Full-Service Catering",
            "Sound and Lighting System"
        ],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d95230.86755205364!2d-6.3874382!3d53.3330612!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9dc3c78e6f%3A0x4c7c0b28f310c8a0!2sDublin%2C%20Ireland!5e0!3m2!1sen!2s!4v1715801234567!5m2!1sen!2s" 
    },
    {
        id: 6,
        image: images.venue6,
        title: "Historic Mansion",
        details: {
            venueType: "Heritage Event Space",
            indoorOutdoor: "Indoor",
            eventType: "Wedding, Gala, Corporate Event, Anniversary Party",
            capacity: 150,
            styleDecor: "Classic Elegance",
            area: "4000 sq ft",
            pricing: "Venue Rental Only: $6000, Venue + Catering: $9500",
            phoneNumber: "+123-456-7890",
            email: "info@venueexample.com",
            address: "Old Town District, Historic Square",
            website: "www.venuewebsite.com",
            parking: "Street Parking Available"
        },
        paragraphs: [
            "Step back in time and host your event in the grandeur of our Historic Mansion, located in the heart of the Old Town District, where history and elegance meet.",
            "This beautifully preserved venue offers sophisticated charm, with antique decor, high ceilings, and luxurious finishes, ideal for unforgettable weddings, galas, and more."
        ],
        gallery: [
            images.venue6Gallery1,
            images.venue6Gallery2,
            images.venue6Gallery3,
            images.venue6Gallery4,
            images.venue6Gallery5,
            images.venue6Gallery6
        ],
        venueSpaces: [
            "Main Hall - Capacity: 150, 4000 sq ft",
            "Ballroom - Capacity: 80",
            "Library - Capacity: 40",
            "Garden Courtyard - Capacity: 100",
            "VIP Lounge - Capacity: 50"
        ],
        amenities: [
            "High Ceilings",
            "Antique Furnishings",
            "Full-Service Catering",
            "Private Gardens",
            "Event Planning Assistance"
        ],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d95230.86755205364!2d-6.3874382!3d53.3330612!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9dc3c78e6f%3A0x4c7c0b28f310c8a0!2sDublin%2C%20Ireland!5e0!3m2!1sen!2s!4v1715801234567!5m2!1sen!2s" 
    }

];

export default venues;